import { BoxRegular } from '@fluentui/react-icons'

export const EntityTypeCard = ({
  name,
  description,
  cardMenu,
  fileTemplatesListPopover,
  dataAssetsListPopover,
}: {
  name: string
  description: string
  cardMenu: React.ReactNode
  fileTemplatesListPopover: React.ReactNode
  dataAssetsListPopover: React.ReactNode
}) => {
  const icon = (
    <div className="flex h-12 w-12 flex-shrink-0 flex-grow-0 items-center justify-center self-start rounded-full bg-muted p-2 text-foreground/50">
      <BoxRegular fontSize={34} />
    </div>
  )

  const titleDescription = (
    <div className="flex flex-col justify-between gap-1">
      <div className="text-base">{name}</div>
      <div className="text-xs font-light">{description}</div>
    </div>
  )

  return (
    // <div className="grid grid-cols-[1fr_4fr_1fr] gap-2 rounded-lg bg-background p-4 shadow">
    <div className="grid grid-cols-[1fr_4fr_1fr] gap-2 bg-background p-4 shadow">
      {icon}
      {titleDescription}
      <div className="flex justify-end">{cardMenu}</div>
      <div className="col-span-2 col-start-2 flex flex-row justify-end gap-2 border-t pt-3">
        {fileTemplatesListPopover}
        {dataAssetsListPopover}
      </div>
    </div>
  )
}
